module.exports = __webpack_public_path__ + "static/media/creator_empty_state.6119837a.svg";